const COOKE_PREFIX = process.env.NODE_ENV === 'production' ? '__Host-' : '';

export const SESSION_COOKIE_KEY = COOKE_PREFIX + 'session';
export const STORAGE_COOKIE_KEY = COOKE_PREFIX + 'storage';
export const CART_SESSION_COOKIE_KEY = COOKE_PREFIX + 'cart';
export const ANALYTICS_COOKIE_KEY = COOKE_PREFIX + 'analytics';
